import s from './Energy.module.sass';

import { useSelector } from 'react-redux';
import { selectMine } from '$store/mine';
import React, { FC, useEffect, useRef, useState } from 'react';
import { IcHot28 } from '$assets';
import { estimateEnergy } from '$store/mine/sagas';

export const Energy: FC = () => {
  const { coins, energy, energyLimit, ts, earnPerShake } = useSelector(selectMine);
  const [estimatedEnergy, setEstimatedEnergy] = useState(energy);
  const [decr, setDecr] = useState(0);
  const prevEnergy = useRef(coins);

  const actualEnergy = Math.max(0, estimatedEnergy - decr);
  const progress = Math.min(100, (actualEnergy / energyLimit) * 100);

  useEffect(() => {
    const diff = Math.max(coins - prevEnergy.current, 0);
    setDecr((prev) => prev + diff);
    prevEnergy.current = coins;
  }, [coins]);

  useEffect(() => {
    setDecr(0);
    setEstimatedEnergy(energy);
    const interval = setInterval(() => {
      setEstimatedEnergy(estimateEnergy(energy, ts, energyLimit));
    }, 1000);

    return () => clearInterval(interval);
  }, [energy, energyLimit, ts]);

  useEffect(() => {
    const el = document.getElementById('shake_button');
    if (el) {
      if (actualEnergy >= earnPerShake) {
        el.classList.remove('disabled');
      } else {
        el.classList.add('disabled');
      }
    }
  }, [actualEnergy, earnPerShake]);

  return (
    <div className={s.wrap}>
      <div className={s.counter}>
        <div className={s.counterIcon}>
          <IcHot28 />
        </div>
        <div className={s.counterValue}>
          {actualEnergy} / {energyLimit}
        </div>
      </div>
      <div className={s.progress}>
        <div className={s.progressIndicator} style={{ width: `${progress}%` }} />
      </div>
    </div>
  );
};
